module["exports"] = [
  "Pan",
  "Pani"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/name/prefix.js
// module id = 2604
// module chunks = 2